// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
export function isEmail(string: string) {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(string)
}

export function doesUsernameHaveLessThan30(string: string) {
  return string.length <= 30
}

export function isUsernameValid(string: string) {
  return /^[a-zA-Z\u4E00-\u9FFF\uFF10-\uFF19\uFF41-\uFF5A\uFF21-\uFF3A]+$/.test(string);
}

export function isValidPassword(string: string) {
  return string.length >= 8 && /^(?=.*[0-9])(?=.*[a-zA-Z]).+$/.test(string);
}

export function isPhoneNumber(string: string) {
  return /^[0-9]+$/.test(string)
}

export function isPersonCertificate(string: string) {
  return /^[a-zA-Z]{2}[0-9]{14}$/.test(string)
}

export function isPersonPhoneBarcode(string: string) {
  return /^\/{1}[0-9A-Z]{7}$/.test(string)
}

export function isCompanyId(string: string) {
  return /^[0-9]{8}$/.test(string)
}
